<div>
  <div class="modal-content">
    <div class="modal-header">
      <h4 class="modal-title">
        Información para preaprobación de crédito
      </h4>
      <button type="button" class="close" (click)="close()" aria-label="Close">
        <span aria-hidden="true">&times;</span>
      </button>
    </div>
    <div class="modal-body">
      <form [formGroup]="preApprovalForm!">
        <div class="form-group">
          <label for="txtAmountToBill">Salario mensual</label>
          <input type="number" class="form-control"
            [ngClass]="{'is-invalid': preApprovalForm!.controls.monthIncome?.errors?.required}" id="txtAmountToBill"
            formControlName="monthIncome" required>
          <div class="invalid-feedback">
            Por favor ingrese un monto valido
          </div>
        </div>
      </form>
    </div>
    <div class="modal-footer">
      <button type="button" class="btn btn-outline-secondary" (click)="close()">Cancelar</button>
      <button type="button" class="btn btn-outline-primary" (click)="handlePreApproveClick()">Pre Aprobar</button>
    </div>
  </div>
</div>
